import styled from 'styled-components';
import { P, fs, radius } from '../../theme/tokens';

export const SavedNote = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 10px 12px;
  border: 1px solid color-mix(in oklch, ${P.success}, white 65%);
  border-radius: ${radius.md}px;
  background: color-mix(in oklch, ${P.success}, white 88%);
  color: color-mix(in oklch, ${P.success}, black 25%);
  font-size: ${fs.xs}px;
  font-weight: 600;

  svg {
    font-size: 12px;
  }
`;
